import React, { Component } from 'react';
import { DatePicker, Row, Col, Button, Tooltip, Table } from 'antd';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import './OnOffline.css';

const { RangePicker } = DatePicker;
/**
 *
 * @param {[moment.Moment, moment.Moment]} current
 * @param {[moment.Moment, moment.Moment]} self
 * @returns {boolean}
 */
const isSelected = (current, self) => {
  return current[0].isSame(self[0], 'day') && current[1].isSame(self[1], 'day');
};
/**
 * @param { 0 | 1 | null } status
 */
const getInfo = status => {
  if (status === null) {
    return {
      className: 'null',
      text: '无数据'
    };
  } else if (status) {
    return {
      className: 'online',
      text: '在线'
    };
  } else {
    return {
      className: 'offline',
      text: '离线'
    };
  }
};

const BTNS = [
  {
    label: '今天',
    value: [moment(), moment()]
  },
  {
    label: '近7天',
    value: [moment().subtract(6, 'day'), moment()]
  },
  {
    label: '近30天',
    value: [moment().subtract(29, 'day'), moment()]
  },
  {
    label: '近90天',
    value: [moment().subtract(90, 'day'), moment()]
  }
];

/**
 * @param {{status: string, start: moment.Moment | string, end: moment.Moment | string}} param0
 */
const Tip = ({ status, start, end }) => (
  <Row>
    <Row style={{ width: 220 }}>
      <Col span={6}>状态:</Col>
      <Col span={18}>{status}</Col>
    </Row>
    <Row>
      <Col span={6}>开始:</Col>
      <Col span={18}>{moment(start).format('YYYY-MM-DD HH:mm:ss')}</Col>
    </Row>
    <Row>
      <Col span={6}>结束:</Col>
      <Col span={18}>{moment(end).format('YYYY-MM-DD HH:mm:ss')}</Col>
    </Row>
  </Row>
);

@inject('deviceInfoStore', 'onOfflineStore')
@observer
class OnOffline extends Component {
  componentDidMount() {
    this.loadData();
  }

  changeDate(dates) {
    this.props.onOfflineStore.changeDate(dates);
    this.loadData();
  }

  loadData = () => {
    const { deviceId } = this.props.deviceInfoStore;
    this.props.onOfflineStore.getOnlineLogs(deviceId);
  };

  render() {
    const { start, end, formatData, originData } = this.props.onOfflineStore;
    return (
      <div style={{ padding: '10px 30px' }}>
        <Row style={{ display: 'flex', alignItems: 'center' }}>
          <Col span={2}>日期选择:</Col>
          <Col span={4}>
            <RangePicker
              value={[start, end]}
              onChange={dates => this.changeDate(dates)}
              disabledDate={current =>
                current.isBefore(moment('2017-01-01').startOf('day')) ||
                current.isAfter(moment().endOf('day'))
              }
            />
          </Col>
          {BTNS.map(i => (
            <Col spam={2} offset={1} key={i.label}>
              <Button
                type={isSelected([start, end], i.value) ? 'primary' : 'default'}
                onClick={() => this.changeDate(i.value)}
              >
                {i.label}
              </Button>
            </Col>
          ))}
        </Row>
        <Row style={{ marginTop: 24, fontWeight: 500 }}>
          在线/离线时段分布图
        </Row>
        <Row
          style={{
            marginTop: 24,
            marginBottom: 32,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Col
            span={1}
            style={{ backgroundColor: '#52C41A', height: 20, marginRight: 16 }}
          />
          <Col span={2} style={{ marginRight: 32 }}>
            在线时间段
          </Col>
          <Col
            span={1}
            style={{ backgroundColor: '#F5222D', height: 20, marginRight: 16 }}
          />
          <Col span={2} style={{ marginRight: 32 }}>
            离线时间段
          </Col>
          <Col
            span={1}
            style={{ backgroundColor: '#D1D1D1', height: 20, marginRight: 16 }}
          />
          <Col span={2} style={{ marginRight: 32 }}>
            无数据
          </Col>
        </Row>
        <Row
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '400%',
            transform: 'scaleX(0.25)',
            transformOrigin: 'left top'
          }}
        >
          {formatData.length ? (
            formatData.map((i, index) => {
              const { className, text } = getInfo(i.onlineStatus);
              return (
                <Tooltip
                  key={index}
                  title={<Tip status={text} start={i.start} end={i.end} />}
                >
                  <div
                    style={{
                      width: i.percent + '%'
                    }}
                    className={'c-online-item ' + className}
                  />
                </Tooltip>
              );
            })
          ) : (
            <Tooltip
              title={
                <Tip
                  status="无数据"
                  start={start.startOf('day')}
                  end={end.endOf('day')}
                />
              }
            >
              <div
                className="c-online-item null"
                style={{ borderRadius: 4, width: '100%' }}
              />
            </Tooltip>
          )}
        </Row>
        <Row style={{ margin: '24px 0', fontWeight: 500 }}>上下线记录</Row>
        <Table
          columns={[
            {
              title: '时间',
              dataIndex: 'updateTime'
            },
            {
              title: '描述',
              dataIndex: 'onlineStatus',
              render: text => (
                <div>
                  <span
                    style={{
                      width: 6,
                      height: 6,
                      marginRight: 8,
                      display: 'inline-block',
                      borderRadius: '50%',
                      backgroundColor: !text ? '#F5222D' : '#52C41A'
                    }}
                  />
                  {!text ? '下线' : '上线'}
                </div>
              )
            }
          ]}
          rowKey={i => i.id}
          dataSource={[...originData].reverse()}
          pagination={{
            total: originData.length,
            showSizeChanger: false,
            pageSize: 20
          }}
        />
      </div>
    );
  }
}

export default OnOffline;



// WEBPACK FOOTER //
// ./src/components/DeviceInfo/OnOffline.js